interface ApiError {
  response?: {
    status?: number;
    data?: {
      error?: string;
      message?: string;
    };
  };
}

export function extractApiErrorMessage(
  err: unknown,
  fallback = "Something went wrong. Please try again.",
): string {
  if (err && typeof err === "object") {
    const e = err as ApiError;
    return e.response?.data?.error ?? e.response?.data?.message ?? fallback;
  }
  return fallback;
}

export function getApiErrorStatus(err: unknown): number | undefined {
  if (err && typeof err === "object") {
    const e = err as ApiError;
    return e.response?.status;
  }
  return undefined;
}
